import es from './es-api';
import sd from './snapshot-data';
import ss from '../ui/snapshot';

let snapshotInfo = {
  snapshots : ()=>{
    es.get(es.ep.snapshot._all, data=>{
      sd.snapshots = data.snapshots;
    }, xhr=>{
      if(xhr.status === 404){
        snapshotInfo.logSet();
      }
    });
  },
  restore : (snapshot, param)=>{
    es.post(es.ep.snapshot.restore(snapshot), param, data=>{
      alert(JSON.stringify(data));
    }, xhr=>{
      if (xhr.status === 500) {
        alert(xhr.responseJSON.error.reason);
      }
    });
  },
  delete : snapshot=>{
    es.delete(es.ep.snapshot.delete(snapshot),'', data=>{
      alert(JSON.stringify(data));
      ss.bindSnapshot();
    }, xhr=>{
      if (xhr.status === 500) {
        alert(xhr.responseJSON.error.reason);
      }
    });
  },
  logSet : ()=>{
    let settings = {
      type: "fs",
      settings: {
        compress: "false",
        location: "/disk/data/LOGBACKUP"
      }
    };
    es.put(es.ep.snapshot.log, JSON.stringify(settings), ()=>{
      es.get(es.ep.snapshot._all, data=>{
        sd.snapshots = data.snapshots;
      });
    });
  },
  close : name=>{
    es.post(es.ep.indices.close(name));
  }
}

export default snapshotInfo;


// WEBPACK FOOTER //
// ./src/scripts/data/snapshot-info.js